/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import React from 'react';

import { Color } from '../../../shared/constants/Colors';
import * as S from './Icon.styles';

export const IconTheme = {
  WOOCLAP: 'wooclap',
  WOOFLASH: 'wooflash',
};

export const IconSize = {
  MICRO: 'micro',
  LITTLE: 'little',
  REDUCED: 'reduced',
  REGULAR: 'regular',
  BIG: 'big',
};

export const IconAppearance = {
  PRIMARY: 'primary',
  MINIMAL: 'minimal',
  BASIC: 'basic',
  CONTACT: 'contact',
};

export const Icon = ({
  appearance,
  hasGradientBackground,
  backgroundColor,
  customColor,
  children,
  size,
  theme,
}) => {
  if (!children) {
    return null;
  }

  return (
    <S.StyledIcon
      appearance={appearance}
      backgroundColor={backgroundColor}
      customColor={customColor}
      hasGradientBackground={hasGradientBackground}
      size={size}
      theme={theme}
    >
      <S.LinearGradient
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
      >
        <linearGradient
          id='custom-gradient'
          x1='100%'
          x2='0%'
          y1='0%'
          y2='100%'
        >
          <stop
            offset='0%'
            stopColor={
              theme === IconTheme.WOOCLAP
                ? Color.BLUE_DODGER
                : Color.CORNFLOWER_MAUVE
            }
          />
          <stop
            offset='100%'
            stopColor={
              theme === IconTheme.WOOCLAP
                ? Color.BLUE_RIBBON
                : Color.CORNFLOWER_MAUVE_LIGHT
            }
          />
        </linearGradient>
      </S.LinearGradient>
      {children}
    </S.StyledIcon>
  );
};

Icon.propTypes = {
  /**
   * Set the icon appearance.
   */
  appearance: PropTypes.oneOf(Object.values(IconAppearance)),
  /**
   * Set an optional background color
   * if the icon type is primary.
   */
  backgroundColor: PropTypes.string,
  /**
   * FontAwesome icons from the React Icons package.
   */
  children: PropTypes.node.isRequired,
  /**
   * Set an optional color to the icon.
   */
  customColor: PropTypes.oneOf(Object.values(Color)),
  /**
   * Set the background to a fade bluegradient only
   * if the icon type is primary.
   */
  hasGradientBackground: PropTypes.bool,
  /**
   * Set the icon size.
   */
  size: PropTypes.oneOf(Object.values(IconSize)),
  /**
   * Changes the appearance of the icon:
   * Wooclap or Wooflash.
   */
  theme: PropTypes.string,
};

Icon.defaultProps = {
  appearance: IconAppearance.PRIMARY,
  hasGradientBackground: false,
  size: IconSize.REGULAR,
  theme: IconTheme.WOOCLAP,
};
